import loadable from '@loadable/component';

export const LoadableAuthModal = loadable(() =>
  import(/* webpackChunkName: "AuthModal" */ './containers/AuthModal'),
);
